// extracted by mini-css-extract-plugin
export var faqSection = "styles-module--faqSection--0f21c";